// extracted by mini-css-extract-plugin
module.exports = {"collection-headline":"story-type-card_collection-headline__2YY7m","threshold-reached":"story-type-card_threshold-reached__3Rcv9"};